import Joi from '@hapi/joi'

export const TaskDetailReportschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    category: Joi.number().invalid(0).required().label("Category").messages({
        "any.invalid": `Select Category`,
        "any.required": `Category required`
    }),
    task: Joi.number().invalid(0).required().label("Task").messages({
        "any.invalid": `Select Task`,
        "any.required": `Task required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month required`
    }),

    

    
}

